<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_mbTtlDlg_styleComponentAnimation()">
		<template v-if="$_mbTtlDlg_stateComponentIsInitialized">
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn"
							:color="isFalse(messageState_.title) ? 'secondary' : 'primary'"
							dark
							icon
							v-on="on"
							@click="$_mbTtlDlg_open()">
						<v-icon>email</v-icon>
					</v-btn>
				</template>
				<template v-if="!isFalse(messageState_.title)">
					<span v-text="messageState_.title" />
				</template>
				<template v-else>
					Not Set
				</template>
				<v-dialog
						v-model="show_"
						max-width="600px"
						persistent>
					<v-card>
						<v-card-title>Title</v-card-title>
						<v-card-text>
							<v-text-field
									clearable
									hide-details
									outlined
									v-model="title_" />
						</v-card-text>
						<v-card-actions>
							<v-row justify="center" dense>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_mbTtlDlg_styleSaveButtonBlock"
											:color="$_mbTtlDlg_styleSaveButtonColor"
											:dark="$_mbTtlDlg_styleSaveButtonDark"
											:depressed="$_mbTtlDlg_styleSaveButtonDepressed"
											:elevation="$_mbTtlDlg_styleSaveButtonElevation"
											:large="$_mbTtlDlg_styleSaveButtonLarge"
											:light="$_mbTtlDlg_styleSaveButtonLight"
											:outlined="$_mbTtlDlg_styleSaveButtonOutlined"
											:rounded="$_mbTtlDlg_styleSaveButtonRounded"
											:small="$_mbTtlDlg_styleSaveButtonSmall"
											:text="$_mbTtlDlg_styleSaveButtonFlat"
											@click="$_mbTtlDlg_save()">
										Save
									</v-btn>
								</v-col>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_mbTtlDlg_styleCloseButtonBlock"
											:color="$_mbTtlDlg_styleCloseButtonColor"
											:dark="$_mbTtlDlg_styleCloseButtonDark"
											:depressed="$_mbTtlDlg_styleCloseButtonDepressed"
											:elevation="$_mbTtlDlg_styleCloseButtonElevation"
											:large="$_mbTtlDlg_styleCloseButtonLarge"
											:light="$_mbTtlDlg_styleCloseButtonLight"
											:outlined="$_mbTtlDlg_styleCloseButtonOutlined"
											:rounded="$_mbTtlDlg_styleCloseButtonRounded"
											:small="$_mbTtlDlg_styleCloseButtonSmall"
											:text="$_mbTtlDlg_styleCloseButtonFlat"
											@click="$_mbTtlDlg_close()">
										Close
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-tooltip>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MessagebarTitleDialog',
		data() {
			return {
				componentName_: 'messagebarTitleDialog',

				messageState_: {},

				title_: null,

				show_: false
			}
		},
		computed: {
			// state
			$_mbTtlDlg_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_mbTtlDlg_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mbTtlDlg_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_mbTtlDlg_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mbTtlDlg_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mbTtlDlg_inits(), 'component')
				}
			},
			$_mbTtlDlg_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mbTtlDlg_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mbTtlDlg_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_mbTtlDlg_inits(), 'chip')
			},
			$_mbTtlDlg_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_mbTtlDlg_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_mbTtlDlg_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_mbTtlDlg_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_mbTtlDlg_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_mbTtlDlg_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_mbTtlDlg_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_mbTtlDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			$_mbTtlDlg_styleCloseButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbTtlDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbTtlDlg_inits(), 'closeButton')
			},
			$_mbTtlDlg_styleCloseButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbTtlDlg_styleCloseButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbTtlDlg_styleCloseButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbTtlDlg_styleCloseButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbTtlDlg_styleCloseButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbTtlDlg_styleCloseButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbTtlDlg_styleCloseButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbTtlDlg_styleCloseButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbTtlDlg_styleCloseButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbTtlDlg_styleCloseButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbTtlDlg_styleCloseButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_mbTtlDlg_styleSaveButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbTtlDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbTtlDlg_inits(), 'saveButton')
			},
			$_mbTtlDlg_styleSaveButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbTtlDlg_styleSaveButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbTtlDlg_styleSaveButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbTtlDlg_styleSaveButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbTtlDlg_styleSaveButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbTtlDlg_styleSaveButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbTtlDlg_styleSaveButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbTtlDlg_styleSaveButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbTtlDlg_styleSaveButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbTtlDlg_styleSaveButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbTtlDlg_styleSaveButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbTtlDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		beforeMount() {
			const self_ = this;
			
			self_.messageState_ = self_.getState('message')
		},
		methods: {
			$_mbTtlDlg_open() {
				const self_ = this;
				
				self_.title_ = self_.messageState_.title;

				self_.show_ = true;
			},
			$_mbTtlDlg_save() {
				const self_ = this;
				
				self_.messageState_.title = self_.title_;

				self_.$_mbTtlDlg_close()
			},
			$_mbTtlDlg_close() {
				const self_ = this;
				self_.show_ = false;
			}
		}
	}
</script>

<style scoped>
	.row_ {
		min-height: 64px;
	}
	.overflow_ {
		max-width: 50px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
